(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-game-promotions/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-game-promotions/assets/javascripts/init.js');
"use strict";


const init = options => {
  const $widgetEl = options.$el[0];
  svs.components.lbUi.carousel.init($widgetEl);
};
setGlobal('svs.banner_groups.banner_game_promotions', {
  init
});

 })(window);